<template>
  <div>
    <cta-banner :title="$route.name"/>
    <div class="bg-white mb-10 mt-5">
      <nav class="flex flex-col sm:flex-row justify-center">
        <template v-for="type in speakerTypes">
          <button v-if="speakersByType[type.value] && speakersByType[type.value].length"
            :key="type.value"
            @click="changeSpeaker(type.value)"
            :class="typeSpeaker === type.value ? 'text-theme-color border-b-2 font-medium border-theme-color' : null"
            class=" py-4 px-6 block hover:text-theme-color focus:outline-none">
            {{ type.label }}
          </button>
        </template>
      </nav>
    </div>
    <cta-conferencista v-for="speaker in speakers" :key="speaker.nombre" :nombre="speaker.nombre" :tipo="speaker.tipo" :descripcion="speaker.descripcion" :foto="speaker.foto" :universidad="speaker.universidad" :ciudad="speaker.ciudad" :areat="speaker.areat" :tema="speaker.tema" :link="speaker.link" :cupo="speaker.cupos" />
  </div>
</template>

<script>
import CtaBanner from '../../components/common/CtaBanner.vue';
import CtaConferencista from '../../components/CtaConferencista.vue';
import API from "@/api";
import {mapState} from "vuex";

export default {
  name: "Conferencista",
  components: {
    CtaBanner,
    CtaConferencista
  },
  data() {
    return {
      speakerTypes: [
        { value: "Conferencista", label: "Conferencistas" },
        { value: "Tallerista", label: "Talleristas" },
        { value: "Ponente", label: "Ponentes" },
        { value: "Panelista", label: "Panelistas" },
      ],
      speakersByType: {},
      typeSpeaker: null,
    };
  },
  computed: {
    ...mapState(["idEventoActual"]),
    speakers() {
      return this.speakersByType[this.typeSpeaker] || [];
    },
  },
  created() {
    this.getSpeakers();
  },
  methods: {
    changeSpeaker(speaker) {
      this.typeSpeaker = speaker;
    },
    async getSpeakers() {
      const results = await Promise.all(
        this.speakerTypes.map(async ({ value }) => {
          const params = {
            "evento_fk" : this.idEventoActual,
            format:  "json",
            tipo: value
          };
          const { data } = await API.getSpeakers(params);
          return [value, data.results];
        })
      );
      this.speakersByType = Object.fromEntries(results);
      const first = this.speakerTypes.find(({ value }) => this.speakersByType[value].length);
      this.typeSpeaker = first ? first.value : null;
    }
  },
};
</script>
